import React, { Dispatch, SetStateAction } from "react";
import { Query, QueryResult } from "react-apollo";
import gql from "graphql-tag";
import Select from "react-select";
import useDebounce from "../../lib/hooks/useDebounce";
import { Text, FormControl, FormLabel } from "@chakra-ui/react";
import { SelectedOption } from "./AssignsFavorites";

const UserSearchQuery = gql`
  query UserSearchQuery(
    $limit: Int
    $search: String
    $role: String
    $after: String
    $isActive: Boolean
  ) {
    users(
      limit: $limit
      search: $search
      role: $role
      after: $after
      isActive: $isActive
    ) {
      id
      name
      email
    }
  }
`;

interface User {
  id: string;
  email: string;
}

interface UserQueryResults {
  users: User[];
}

interface UserQueryVariables {
  limit?: number;
  offset?: number;
  search?: string;
  after?: string;
  isActive?: boolean;
}

interface UserSelectProps {
  onUserChange: Dispatch<SetStateAction<SelectedOption>>;
  selectedUser: SelectedOption;
}

const UserSelect = ({
  onUserChange,
  selectedUser,
}: UserSelectProps): JSX.Element => {
  const {
    value: searchKeyword,
    deferredValue: deferredKeyword,
    setValue: setKeyword,
  } = useDebounce(250);

  return (
    <Query
      query={UserSearchQuery}
      variables={{
        search: deferredKeyword,
        isActive: true,
      }}
    >
      {({
        data,
        error,
        fetchMore,
      }: QueryResult<UserQueryResults, UserQueryVariables>) => {
        if (error) return <Text>Error while getting users</Text>;
        if (data?.users) {
          const usersOption = data.users.map((user) => {
            return {
              value: user.id,
              label: user.email,
            };
          });

          return (
            <FormControl>
              <FormLabel htmlFor="email">Select Client</FormLabel>
              <Select
                id="copy-folder-user-select"
                classNamePrefix="user-select"
                value={selectedUser}
                inputValue={searchKeyword}
                filterOption={() => true}
                styles={{
                  control: (styles) => ({ ...styles, height: "45px" }),
                }}
                menuPortalTarget={document.querySelector("body")}
                onChange={(user) => onUserChange(user)}
                onInputChange={(value) => {
                  setKeyword(value);
                }}
                isClearable={true}
                placeholder="Search client by name or email..."
                options={usersOption}
                onMenuScrollToBottom={() => {
                  fetchMore({
                    variables: {
                      after: usersOption[usersOption.length - 1].value,
                    },
                    updateQuery: (prev, { fetchMoreResult }) => {
                      if (!fetchMoreResult) return prev;

                      return {
                        users: [...prev.users, ...fetchMoreResult.users],
                      };
                    },
                  });
                }}
              />
            </FormControl>
          );
        }

        return null;
      }}
    </Query>
  );
};

export default UserSelect;
